import { CLOUDPAYMENTS_CONSTANTS } from '../consts/CLOUDPAYMENTS_CONSTANTS';

/**
 * Load CloudPayments widget script dynamically
 */
export const loadCloudpaymentsScript = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (typeof window !== 'undefined' && (window as any).cp) {
      resolve();
      return;
    }

    const existingScript = document.querySelector(
      `script[src="${CLOUDPAYMENTS_CONSTANTS.SCRIPT_URL}"]`,
    );

    if (existingScript) {
      existingScript.addEventListener('load', () => resolve());
      return;
    }

    const script = document.createElement('script');
    script.src = CLOUDPAYMENTS_CONSTANTS.SCRIPT_URL;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load CloudPayments script'));
    document.head.appendChild(script);
  });
};
